export default __webpack_public_path__ + "static/media/002_BANNER_TECNOLOGIA_DISCO_BANNER_01.602c2b0a.jpg";